export const getCameraCalibrationWorkflowSchema = (type: 'basic' | 'advanced') => {
    if (type === 'basic') {
        return {
            type: "object",
            properties: {
                "size_x": {
                    "description": "Number of interior corners horizontally",
                    "type": "integer" as const,
                    "default": 8
                },
                "size_y": {
                    "description": "Number of interior corners vertically",
                    "type": "integer" as const,
                    "default": 6
                },
                "square_size": {
                    "description": "Size of each chessboard square (mm)",
                    "type": "integer" as const,
                    "default": 25
                },
                "frame_step": {
                    "description": "Process every N frames",
                    "type": "integer" as const,
                    "default": 10
                },
                "min_corner_detections": {
                    "description": "Minimum valid frames required",
                    "type": "integer" as const,
                    "default": 15
                }
            },
            required: []
        };
    } else {
        return {
            type: "object",
            properties: {
                "size_x": {
                    "description": "Number of interior corners horizontally",
                    "type": "integer" as const,
                    "default": 11
                },
                "size_y": {
                    "description": "Number of interior corners vertically",
                    "type": "integer" as const,
                    "default": 9
                },
                "square_size": {
                    "description": "Size of each chessboard square (mm)",
                    "type": "integer" as const,
                    "default": 75
                },
                "frame_step": {
                    "description": "Process every N frames",
                    "type": "integer" as const,
                    "default": 30
                },
                "min_corner_detections": {
                    "description": "Minimum valid frames required",
                    "type": "integer" as const,
                    "default": 15
                }
            },
            required: []
        };
    }
}